import React from "react";
import { Box, Skeleton } from "@mui/material";

const CheckinSkeleton = () => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Header Skeleton */}
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 4 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" width="60%" height={30} />
      </Box>

      {/* Instruction Text Skeleton */}
      <Box sx={{ mt: 5 }}>
        <Skeleton
          variant="text"
          width="80%"
          height={20}
          sx={{ mx: "auto", mb: 2 }}
        />

        {/* Time Selection Skeleton */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Skeleton variant="text" width="30%" height={25} />
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ borderRadius: "28px" }}
          />
        </Box>

        {/* Footer Button Skeleton */}
        <Box sx={{ mt: 5 }}>
          <Skeleton
            variant="rectangular"
            height={50}
            width="100%"
            sx={{ borderRadius: "10px" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CheckinSkeleton;
